import "./ObjEdit.css";
import css from "./ObjEdit.module.css";

import { widgets, getEditWgt } from "../widgets";
import { useState } from "react";

// form and prefix
export default function ObjEdit({objTpl:objTplIn, objVal:objValIn, form, forms, path:pathIn}){
    const [objTpl, setObjTpl] = useState(objTplIn || {});
    const [objVal, setObjVal] = useState(objValIn || {});
    const [curTpl, setCurTpl] = useState('objEdit');
    console.log('...objVal:', objVal);

    return <div>
        {/* [] since TblDefEdit is used in JsonTblEdit, if use form may cause form embeded in form error */}
        <div className={["input-group mb-3", css.bg].join(' ')}>
            <select className="form-select"
                defaultValue={curTpl}
                onClick={evt=>{
                    setCurTpl(evt.target.value);
                }}
            >
                {Object.keys(widgets).map(wgt=><option
                    key={wgt}
                    value={wgt}>{wgt}</option>)
                }
            </select>
            <button type="button"
                className="btn btn-sm btn-primary"
                title="add sub node"
                onClick={evt=>{
                    const newItemName = prompt("input new item name:");
                    if(!newItemName)return;

                    if(objTpl[newItemName]){
                        alert('item exists.')
                        return;
                    }

                    const objTplNew = {};
                    objTplNew[newItemName] = {
                        type: curTpl
                    };
                    setObjTpl({...objTpl, ...objTplNew});
                }}
            >+</button>

            <span className="bg-primary">
                <button type="button"
                    title="move up"
                    className={["btn btn-sm btn-primary mx-1", css['up-arrow']].join(' ')}
                ></button>
            </span>
                
            <span className="bg-primary">
                <button type="button"
                    title="move down"
                    className={["btn btn-sm btn-primary mx-1", css['down-arrow']].join(' ')}
                ></button>
            </span>

            <button type="button"
                className="btn btn-sm btn-warning"
                title="delte"
            >X</button>
        </div>


        <div role="form">
            {Object.keys(objTpl).map(attrName=>{
                const attrDef = objTpl[attrName] || {};
                const AttrEditWgt = getEditWgt(attrDef.type);
                const attrPath = [pathIn, attrName].join(',');
                
                return <div 
                    key={attrName}
                    className="mb-3 d-flex flex-row"
                >
                    <label htmlFor="inputEmail3" className="col-form-label pe-1" style={{flex:"0"}}>{attrDef.caption || attrName}</label>
                    <div className=""  style={{flex:"1"}}>
                        {/* the value of AttrEditWgt is set using form */}
                        <AttrEditWgt
                            fldName={attrPath}
                            // form={form}
                            fldDef={objTpl[attrName]}

                            fldVal={objVal[attrName]}
                            objVal={objVal[attrName]}

                            forms={forms}
                            path={attrPath}
                            // defaultValue={tblDef[attrName] || undefined}
                        ></AttrEditWgt>
                    </div>
                </div>
            })}
        </div>
    </div>;
}
